import React from 'react';

const DashboardIcon = () => {
  return (
    <svg
      width='16'
      height='16'
      viewBox='0 0 16 16'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
    >
      <path
        d='M8 12V10'
        stroke='#232222'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
      <path
        d='M6.71025 1.88023L2.09025 5.58023C1.57025 5.99356 1.23692 6.86689 1.35025 7.52023L2.23692 12.8269C2.39692 13.7736 3.30359 14.5402 4.26359 14.5402H11.7303C12.6836 14.5402 13.5969 13.7669 13.7569 12.8269L14.6436 7.52023C14.7503 6.86689 14.4169 5.99356 13.9036 5.58023L9.28359 1.88689C8.57026 1.31356 7.41692 1.31356 6.71025 1.88023Z'
        stroke='#232222'
        strokeWidth='1.25'
        strokeLinecap='round'
        strokeLinejoin='round'
      />
    </svg>
  );
};

export default DashboardIcon;
